module.exports = __webpack_public_path__ + "static/media/contactUSVNActive.02e24772.png";